<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-explicit-any */
// 9.6 (owner request): a person's activity in two chart models — lines (square-root scale so small series stay
// visible) and stacked bars — with per-bucket details on hover and totals in the legend. Values from chartVals().
import { s } from '../tpl';
defineProps<{ ch: any; compact?: boolean; linesOnly?: boolean }>();
</script>

<template>
<div :style="s('display:flex; flex-direction:column; gap:14px;')">
  <div :style="s('display:flex; gap:12px; flex-wrap:wrap; font-size:12px; color:#9c9da3;')">
    <template v-for="(l, l$i) in ch.legend" :key="l$i"><span :style="s('display:flex; align-items:center; gap:5px;')"><span :style="s(`width:8px; height:8px; border-radius:2px; background:${l.color};`)"></span>{{ l.label }}<b :style="s('color:#e7e7ea; font-weight:700;')">{{ l.val }}</b></span></template>
  </div>
  <div>
    <div :style="s('display:flex; justify-content:space-between; font-size:11px; color:#76777d; margin-bottom:4px;')"><span>نمودار خطی · مقیاس ریشه‌ای تا مقدارهای کم هم دیده شوند</span><span>بیشینه {{ ch.maxL }}</span></div>
    <div :style="s(`position:relative; height:${compact ? '110px' : '150px'};`)">
      <svg viewBox="0 0 100 50" preserveAspectRatio="none" :style="s('position:absolute; inset:0; width:100%; height:100%; overflow:visible; direction:ltr;')">
        <line x1="0" y1="4" x2="100" y2="4" stroke="#2f3035" stroke-width="1" vector-effect="non-scaling-stroke"></line>
        <line x1="0" y1="26" x2="100" y2="26" stroke="#2f3035" stroke-width="1" vector-effect="non-scaling-stroke"></line>
        <line x1="0" y1="48" x2="100" y2="48" stroke="#45464b" stroke-width="1" vector-effect="non-scaling-stroke"></line>
        <template v-for="(ln, ln$i) in ch.lines" :key="ln$i"><polyline :points="ln.pts" fill="none" :stroke="ln.color" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke" :opacity="ln.op"></polyline></template>
      </svg>
      <div :style="s('position:absolute; inset:0; display:flex; direction:ltr;')">
        <template v-for="(cl, cl$i) in ch.cols" :key="cl$i"><div :title="cl.title" :style="s('flex:1; min-width:0;')" class="ap-uc-col"></div></template>
      </div>
    </div>
    <div :style="s('display:flex; justify-content:space-between; font-size:11px; color:#8a8b91; margin-top:6px; direction:ltr;')"><span>{{ ch.fromL }}</span><span>{{ ch.toL }}</span></div>
  </div>
  <div v-if="!linesOnly">
    <div :style="s('display:flex; justify-content:space-between; font-size:11px; color:#76777d; margin-bottom:4px;')"><span>نمودار ستونی · مجموع هر بازه</span><span>بیشینه {{ ch.barMaxL }}</span></div>
    <div :style="s(`display:flex; align-items:stretch; gap:2px; height:${compact ? '90px' : '120px'}; direction:ltr;`)">
      <template v-for="(b, b$i) in ch.bars" :key="b$i">
        <div :title="b.title" :style="s('flex:1; min-width:0; display:flex; flex-direction:column-reverse; gap:1px;')"><template v-for="(sg, sg$i) in b.segs" :key="sg$i"><div :style="s(`height:${sg.h}; background:${sg.color}; border-radius:2px;`)"></div></template></div>
      </template>
    </div>
    <div :style="s('display:flex; justify-content:space-between; font-size:11px; color:#8a8b91; margin-top:6px; direction:ltr;')"><span>{{ ch.fromL }}</span><span>{{ ch.toL }}</span></div>
  </div>
</div>
</template>

<style scoped>
.ap-uc-col:hover { background: rgba(255, 255, 255, 0.05); }
</style>
